export default {
  milk2: '0x6866c447eaEF27D520D91523e670c6E8a917E8d1',
  sidusPresale: '0x9A8602872d351788AF00dC49DdbF97aA8a246aDA',
  shadow: '0xa203D7f73E2928368CB03559bcfd0cF7f2B50034',
  shake: '0xd8ecE16c308d6E39D1e79c1C3Ff06FAB4F042057',
  shadowBridge: '0x265609202602885453342E4653ff334E0A9aF76F',
};
